export const baseUrl='https://khairokomapi1.azurewebsites.net'
//'https://khairokom2.azurewebsites.net'

//'https://noon1.azurewebsites.net/'

 
